export default function getCloudFlareImage(imageId) {
  return `https://imagedelivery.net/i_c4IEOT2tT7mgiSYLaLwA/${imageId}/public`;
}
